import angular from 'angular';
import template from './app.html';

import './app.less';

class AppController {
    constructor() {
        'ngInject';
    }

    $onInit() {
    }
}

export const AppComponent = {
    name: 'mmsApp',
    component: {
        template: template,
        controller: AppController,
        bindings: {}
    }
};


// WEBPACK FOOTER //
// ./src/app/app.component.js